import axios from 'axios';

import {
  EMPLOYEE_QUALIFICATION,
  EMPLOYEES_QUALIFICATIONS,
  REQUEST_QUALIFICATIONS
} from 'RestAPIs/endpoints';
import { RequestQualifications } from './types';

type NewEmployeeQualification = {
  qualificationId: string;
  startDate: string;
  endDate: string | null;
};

export type EmployeeQualification = NewEmployeeQualification & {
  id: string;
  qualificationName: string;
  canBeEdited: boolean;
};

export const getEmployeeQualifications = (employeeId: number) =>
  axios.get<EmployeeQualification[]>(EMPLOYEES_QUALIFICATIONS, {
    pathParams: { employeeId }
  });

export const addEmployeeQualification = (
  employeeId: number,
  body: NewEmployeeQualification
) =>
  axios.post<EmployeeQualification>(
    EMPLOYEES_QUALIFICATIONS,
    { ...body },
    {
      pathParams: { employeeId }
    }
  );

export const updateEmployeeQualification = (
  employeeId: number,
  qualificationId,
  body: NewEmployeeQualification
) =>
  axios.put<EmployeeQualification>(
    EMPLOYEE_QUALIFICATION,
    {
      startDate: body.startDate,
      endDate: body.endDate
    },
    {
      pathParams: { employeeId, qualificationId }
    }
  );

export const removeEmployeeQualification = (
  employeeId: number,
  qualificationId
) =>
  axios.delete(EMPLOYEE_QUALIFICATION, {
    pathParams: { employeeId, qualificationId }
  });

export const getRequestQualifications = (requestId: number) =>
  axios.get<RequestQualifications[]>(REQUEST_QUALIFICATIONS, {
    pathParams: { requestId }
  });
